
import { motion } from "framer-motion";
import { Heart, Calculator, FileText, Check } from "lucide-react";
import { Link } from "react-router-dom";

export const WeddingApplicationSteps = () => {
  // Default loan parameters for the wedding loan
  const defaultLoanAmount = 15000;
  const defaultLoanTerm = 5;
  const applicationUrl = `/kilpailuta?amount=${defaultLoanAmount}&term=${defaultLoanTerm}&type=haalaina`;

  const steps = [
    {
      icon: <Calculator className="h-10 w-10 text-pink-500" />,
      title: "Laske häälainan tarve",
      description: "Käytä laskuria selvittääksesi sopiva lainasumma ja kuukausierä."
    },
    {
      icon: <FileText className="h-10 w-10 text-pink-500" />,
      title: "Täytä hakemus verkossa",
      description: "Täytä lainahakemus helposti ja turvallisesti verkossa vain muutamassa minuutissa."
    },
    {
      icon: <Check className="h-10 w-10 text-pink-500" />,
      title: "Saa tarjoukset",
      description: "Vertaile pankkien tarjouksia ja valitse paras vaihtoehto häidesi rahoittamiseen."
    },
    {
      icon: <Heart className="h-10 w-10 text-pink-500" />,
      title: "Nauti unelmiesi häistä",
      description: "Toteuta täydelliset häät ilman taloudellisia huolia ja stressiä."
    }
  ];
  
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      custom={3}
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: (i: number) => ({
          opacity: 1,
          y: 0,
          transition: {
            delay: i * 0.1,
            duration: 0.5,
          }
        })
      }}
    >
      <div className="bg-gradient-to-r from-pink-50 to-pink-100 rounded-lg p-6 border border-pink-100">
        <h2 className="text-2xl font-bold text-pink-700 mb-6">Näin haet häälainaa</h2>
        
        <div className="space-y-4">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start bg-white p-4 rounded-lg shadow-sm">
              <div className="mr-4">
                {step.icon}
              </div>
              <div>
                <h3 className="font-semibold text-pink-700">{step.title}</h3>
                <p className="text-gray-600 text-sm">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-6 text-center">
          <Link 
            to={applicationUrl}
            className="bg-pink-600 hover:bg-pink-700 text-white px-6 py-2 rounded-md font-medium inline-block"
          >
            Aloita hakeminen nyt
          </Link>
        </div>
      </div>
    </motion.div>
  );
};
